// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file_browser {
    width: 100%;
    border: 1px solid var(--color-border);
    border-radius: 4px;
    background-color: var(--color-bg-2);
    overflow: hidden;
}

.file_browser__toolbar {
    display: flex;
    align-items: center;
    gap: 2px;
    padding: 4px 7px;
    border-bottom: 1px solid var(--color-border);
    background-color: var(--color-bg-1, var(--color-bg));
}

.file_browser__nav_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 3px;
    flex-shrink: 0;
    transition: background-color 0.1s;
}

@media (pointer: fine) {
    .file_browser__nav_btn:not(:disabled):hover {
        background-color: var(--color-bg-3);
    }
}

.file_browser__nav_btn:disabled {
    opacity: 0.3;
    cursor: default;
}

.file_browser__nav_icon {
    display: block;
    width: 8px;
    height: 8px;
    border-right: 2px solid var(--color-text-muted);
    border-bottom: 2px solid var(--color-text-muted);
}

.file_browser__nav_icon--back {
    transform: rotate(135deg);
    margin-left: 2px;
}

.file_browser__nav_icon--forward {
    transform: rotate(-45deg);
    margin-right: 2px;
}

.file_browser__nav_icon--up {
    transform: rotate(-135deg);
    margin-top: 2px;
}

.file_browser__current_name {
    flex: 1;
    padding: 0 7px;
    font-size: 13px;
    font-weight: 600;
    color: var(--color-text);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.file_browser__list {
    padding: 2px 0;
    max-height: 308px;
    overflow-y: auto;
}

.file_browser__loading_row {
    display: flex;
    align-items: center;
    padding: 4px 9px;
}

.file_browser__spinner {
    display: block;
    width: 13px;
    height: 13px;
    border: 2px solid var(--color-text-muted);
    border-top-color: transparent;
    border-radius: 50%;
    animation: file_browser__spin 0.7s linear infinite;
}

@keyframes file_browser__spin {
    to { transform: rotate(360deg); }
}

.file_browser__empty {
    padding: 9px 13px;
    font-size: 13px;
    color: var(--color-text-muted);
}

.file_browser__entry {
    display: flex;
    align-items: center;
    gap: 7px;
    padding: 3px 9px;
    cursor: default;
    user-select: none;
    border: 1px solid transparent;
}

.file_browser--single-click .file_browser__entry {
    cursor: pointer;
}

@media (pointer: fine) {
    .file_browser__entry:hover {
        background-color: var(--color-bg-3);
    }
}

.file_browser__entry--selected {
    background-color: rgba(88, 157, 246, 0.15);
    border-color: rgba(88, 157, 246, 0.3);
}

@media (pointer: fine) {
    .file_browser__entry--selected:hover {
        background-color: rgba(88, 157, 246, 0.2);
    }
}

.file_browser__entry_icon {
    flex-shrink: 0;
    width: 15px;
    height: 15px;
    position: relative;
}

.file_browser__entry_icon--dir::before {
    content: "";
    display: block;
    width: 13px;
    height: 11px;
    border: 2px solid var(--color-text-muted);
    border-radius: 0 2px 2px 2px;
    position: absolute;
    top: 2px;
    left: 0;
}

.file_browser__entry_icon--dir::after {
    content: "";
    display: block;
    width: 7px;
    height: 3px;
    border: 2px solid var(--color-text-muted);
    border-bottom: none;
    border-radius: 2px 2px 0 0;
    position: absolute;
    top: 0;
    left: 0;
}

.file_browser__entry_icon--file::before {
    content: "";
    display: block;
    width: 11px;
    height: 13px;
    border: 2px solid var(--color-text-muted);
    border-radius: 0 2px 2px 2px;
    position: absolute;
    top: 1px;
    left: 1px;
}

.file_browser__entry_icon--file::after {
    content: "";
    display: block;
    width: 4px;
    height: 4px;
    border-top: 2px solid var(--color-text-muted);
    border-left: 2px solid var(--color-text-muted);
    border-right: 2px solid var(--color-bg-2);
    background-color: var(--color-bg-2);
    position: absolute;
    top: 1px;
    right: 1px;
    transform: rotate(90deg);
}

.file_browser__entry_name {
    flex: 1;
    font-size: 13px;
    color: var(--color-text);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.file_browser__entry_name--git-added {
    color: #73ba6c;
}

.file_browser__entry_name--git-modified {
    color: #e2c081;
}

.file_browser__entry_actions {
    display: flex;
    align-items: center;
    gap: 2px;
    flex-shrink: 0;
    opacity: 0;
    transition: opacity 0.1s;
}

@media (pointer: fine) {
    .file_browser__entry:hover .file_browser__entry_actions {
        opacity: 1;
    }
}

.file_browser__entry_action {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 3px;
    font-size: 14px;
    line-height: 1;
    color: var(--color-text-muted);
    cursor: pointer;
    transition: background-color 0.1s, color 0.1s;
}

@media (pointer: fine) {
    .file_browser__entry_action:hover {
        background-color: var(--color-bg-3);
        color: var(--color-text);
    }

    .file_browser__entry_action--remove:hover {
        color: var(--color-red, #f85149);
    }
}

.file_browser__enter_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    border-radius: 3px;
    opacity: 0;
    transition: opacity 0.1s, background-color 0.1s;
}

@media (pointer: fine) {
    .file_browser__entry:hover .file_browser__enter_btn {
        opacity: 1;
    }
}

@media (pointer: fine) {
    .file_browser__enter_btn:hover {
        background-color: var(--color-bg-3);
    }
}

.file_browser__enter_icon {
    display: block;
    width: 7px;
    height: 7px;
    border-right: 2px solid var(--color-text-muted);
    border-bottom: 2px solid var(--color-text-muted);
    transform: rotate(-45deg);
    margin-right: 1px;
}

/* Tree mode */

.file_browser--tree {
    border: none;
    border-radius: 0;
    background: none;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.file_browser__list--tree {
    flex: 1;
    padding: 2px 0;
    max-height: none;
    overflow-y: auto;
}

.file_browser__tree_arrow {
    flex-shrink: 0;
    display: block;
    width: 13px;
    height: 13px;
    position: relative;
}

.file_browser__tree_arrow::before {
    content: "";
    display: block;
    width: 6px;
    height: 6px;
    border-right: 2px solid var(--color-text-muted);
    border-bottom: 2px solid var(--color-text-muted);
    position: absolute;
    top: 2px;
    left: 3px;
    transform: rotate(-45deg);
    transition: transform 0.1s;
}

.file_browser__tree_arrow--open::before {
    transform: rotate(45deg);
    top: 1px;
}

.file_browser__tree_arrow_spacer {
    flex-shrink: 0;
    display: block;
    width: 13px;
    height: 13px;
}

@media (max-width: 845px) and (orientation: portrait) {
    .file_browser__current_name {
        font-size: 15px;
    }

    .file_browser__entry_name {
        font-size: 15px;
    }

    .file_browser__empty {
        font-size: 15px;
    }
}
`, "",{"version":3,"sources":["webpack://./components/FileBrowser/s.file_browser.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,qCAAqC;IACrC,kBAAkB;IAClB,mCAAmC;IACnC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,4CAA4C;IAC5C,oDAAoD;AACxD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,iCAAiC;AACrC;;AAEA;IACI;QACI,mCAAmC;IACvC;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,WAAW;IACX,+CAA+C;IAC/C,gDAAgD;AACpD;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,yCAAyC;IACzC,6BAA6B;IAC7B,kBAAkB;IAClB,kDAAkD;AACtD;;AAEA;IACI,KAAK,yBAAyB,EAAE;AACpC;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,mCAAmC;IACvC;AACJ;;AAEA;IACI,0CAA0C;IAC1C,qCAAqC;AACzC;;AAEA;IACI;QACI,yCAAyC;IAC7C;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,YAAY;IACZ,yCAAyC;IACzC,4BAA4B;IAC5B,kBAAkB;IAClB,QAAQ;IACR,OAAO;AACX;;AAEA;IACI,WAAW;IACX,cAAc;IACd,UAAU;IACV,WAAW;IACX,yCAAyC;IACzC,mBAAmB;IACnB,0BAA0B;IAC1B,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,YAAY;IACZ,yCAAyC;IACzC,4BAA4B;IAC5B,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,WAAW;IACX,cAAc;IACd,UAAU;IACV,WAAW;IACX,6CAA6C;IAC7C,8CAA8C;IAC9C,yCAAyC;IACzC,mCAAmC;IACnC,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,OAAO;IACP,eAAe;IACf,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,8BAA8B;IAC9B,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI;QACI,mCAAmC;QACnC,wBAAwB;IAC5B;;IAEA;QACI,gCAAgC;IACpC;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,+CAA+C;AACnD;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,mCAAmC;IACvC;AACJ;;AAEA;IACI,cAAc;IACd,UAAU;IACV,WAAW;IACX,+CAA+C;IAC/C,gDAAgD;IAChD,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA,cAAc;;AAEd;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,OAAO;IACP,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,UAAU;IACV,WAAW;IACX,+CAA+C;IAC/C,gDAAgD;IAChD,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;IACxB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,cAAc;IACd,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".file_browser {\n    width: 100%;\n    border: 1px solid var(--color-border);\n    border-radius: 4px;\n    background-color: var(--color-bg-2);\n    overflow: hidden;\n}\n\n.file_browser__toolbar {\n    display: flex;\n    align-items: center;\n    gap: 2px;\n    padding: 4px 7px;\n    border-bottom: 1px solid var(--color-border);\n    background-color: var(--color-bg-1, var(--color-bg));\n}\n\n.file_browser__nav_btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    border-radius: 3px;\n    flex-shrink: 0;\n    transition: background-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .file_browser__nav_btn:not(:disabled):hover {\n        background-color: var(--color-bg-3);\n    }\n}\n\n.file_browser__nav_btn:disabled {\n    opacity: 0.3;\n    cursor: default;\n}\n\n.file_browser__nav_icon {\n    display: block;\n    width: 8px;\n    height: 8px;\n    border-right: 2px solid var(--color-text-muted);\n    border-bottom: 2px solid var(--color-text-muted);\n}\n\n.file_browser__nav_icon--back {\n    transform: rotate(135deg);\n    margin-left: 2px;\n}\n\n.file_browser__nav_icon--forward {\n    transform: rotate(-45deg);\n    margin-right: 2px;\n}\n\n.file_browser__nav_icon--up {\n    transform: rotate(-135deg);\n    margin-top: 2px;\n}\n\n.file_browser__current_name {\n    flex: 1;\n    padding: 0 7px;\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--color-text);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.file_browser__list {\n    padding: 2px 0;\n    max-height: 308px;\n    overflow-y: auto;\n}\n\n.file_browser__loading_row {\n    display: flex;\n    align-items: center;\n    padding: 4px 9px;\n}\n\n.file_browser__spinner {\n    display: block;\n    width: 13px;\n    height: 13px;\n    border: 2px solid var(--color-text-muted);\n    border-top-color: transparent;\n    border-radius: 50%;\n    animation: file_browser__spin 0.7s linear infinite;\n}\n\n@keyframes file_browser__spin {\n    to { transform: rotate(360deg); }\n}\n\n.file_browser__empty {\n    padding: 9px 13px;\n    font-size: 13px;\n    color: var(--color-text-muted);\n}\n\n.file_browser__entry {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n    padding: 3px 9px;\n    cursor: default;\n    user-select: none;\n    border: 1px solid transparent;\n}\n\n.file_browser--single-click .file_browser__entry {\n    cursor: pointer;\n}\n\n@media (pointer: fine) {\n    .file_browser__entry:hover {\n        background-color: var(--color-bg-3);\n    }\n}\n\n.file_browser__entry--selected {\n    background-color: rgba(88, 157, 246, 0.15);\n    border-color: rgba(88, 157, 246, 0.3);\n}\n\n@media (pointer: fine) {\n    .file_browser__entry--selected:hover {\n        background-color: rgba(88, 157, 246, 0.2);\n    }\n}\n\n.file_browser__entry_icon {\n    flex-shrink: 0;\n    width: 15px;\n    height: 15px;\n    position: relative;\n}\n\n.file_browser__entry_icon--dir::before {\n    content: \"\";\n    display: block;\n    width: 13px;\n    height: 11px;\n    border: 2px solid var(--color-text-muted);\n    border-radius: 0 2px 2px 2px;\n    position: absolute;\n    top: 2px;\n    left: 0;\n}\n\n.file_browser__entry_icon--dir::after {\n    content: \"\";\n    display: block;\n    width: 7px;\n    height: 3px;\n    border: 2px solid var(--color-text-muted);\n    border-bottom: none;\n    border-radius: 2px 2px 0 0;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n\n.file_browser__entry_icon--file::before {\n    content: \"\";\n    display: block;\n    width: 11px;\n    height: 13px;\n    border: 2px solid var(--color-text-muted);\n    border-radius: 0 2px 2px 2px;\n    position: absolute;\n    top: 1px;\n    left: 1px;\n}\n\n.file_browser__entry_icon--file::after {\n    content: \"\";\n    display: block;\n    width: 4px;\n    height: 4px;\n    border-top: 2px solid var(--color-text-muted);\n    border-left: 2px solid var(--color-text-muted);\n    border-right: 2px solid var(--color-bg-2);\n    background-color: var(--color-bg-2);\n    position: absolute;\n    top: 1px;\n    right: 1px;\n    transform: rotate(90deg);\n}\n\n.file_browser__entry_name {\n    flex: 1;\n    font-size: 13px;\n    color: var(--color-text);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.file_browser__entry_name--git-added {\n    color: #73ba6c;\n}\n\n.file_browser__entry_name--git-modified {\n    color: #e2c081;\n}\n\n.file_browser__entry_actions {\n    display: flex;\n    align-items: center;\n    gap: 2px;\n    flex-shrink: 0;\n    opacity: 0;\n    transition: opacity 0.1s;\n}\n\n@media (pointer: fine) {\n    .file_browser__entry:hover .file_browser__entry_actions {\n        opacity: 1;\n    }\n}\n\n.file_browser__entry_action {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 18px;\n    height: 18px;\n    border-radius: 3px;\n    font-size: 14px;\n    line-height: 1;\n    color: var(--color-text-muted);\n    cursor: pointer;\n    transition: background-color 0.1s, color 0.1s;\n}\n\n@media (pointer: fine) {\n    .file_browser__entry_action:hover {\n        background-color: var(--color-bg-3);\n        color: var(--color-text);\n    }\n\n    .file_browser__entry_action--remove:hover {\n        color: var(--color-red, #f85149);\n    }\n}\n\n.file_browser__enter_btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: 20px;\n    height: 20px;\n    border-radius: 3px;\n    opacity: 0;\n    transition: opacity 0.1s, background-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .file_browser__entry:hover .file_browser__enter_btn {\n        opacity: 1;\n    }\n}\n\n@media (pointer: fine) {\n    .file_browser__enter_btn:hover {\n        background-color: var(--color-bg-3);\n    }\n}\n\n.file_browser__enter_icon {\n    display: block;\n    width: 7px;\n    height: 7px;\n    border-right: 2px solid var(--color-text-muted);\n    border-bottom: 2px solid var(--color-text-muted);\n    transform: rotate(-45deg);\n    margin-right: 1px;\n}\n\n/* Tree mode */\n\n.file_browser--tree {\n    border: none;\n    border-radius: 0;\n    background: none;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.file_browser__list--tree {\n    flex: 1;\n    padding: 2px 0;\n    max-height: none;\n    overflow-y: auto;\n}\n\n.file_browser__tree_arrow {\n    flex-shrink: 0;\n    display: block;\n    width: 13px;\n    height: 13px;\n    position: relative;\n}\n\n.file_browser__tree_arrow::before {\n    content: \"\";\n    display: block;\n    width: 6px;\n    height: 6px;\n    border-right: 2px solid var(--color-text-muted);\n    border-bottom: 2px solid var(--color-text-muted);\n    position: absolute;\n    top: 2px;\n    left: 3px;\n    transform: rotate(-45deg);\n    transition: transform 0.1s;\n}\n\n.file_browser__tree_arrow--open::before {\n    transform: rotate(45deg);\n    top: 1px;\n}\n\n.file_browser__tree_arrow_spacer {\n    flex-shrink: 0;\n    display: block;\n    width: 13px;\n    height: 13px;\n}\n\n@media (max-width: 845px) and (orientation: portrait) {\n    .file_browser__current_name {\n        font-size: 15px;\n    }\n\n    .file_browser__entry_name {\n        font-size: 15px;\n    }\n\n    .file_browser__empty {\n        font-size: 15px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
